import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const bordersListDefaultVariants = {}
const bordersListCompoundVariants = []

const bordersListSlotNames = [
  [
    "root",
    "borders-list__root"
  ],
  [
    "item",
    "borders-list__item"
  ]
]
const bordersListSlotFns = /* @__PURE__ */ bordersListSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, bordersListDefaultVariants, getSlotCompoundVariant(bordersListCompoundVariants, slotName))])

const bordersListFn = memo((props = {}) => {
  return Object.fromEntries(bordersListSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const bordersListVariantKeys = []
const getVariantProps = (variants) => ({ ...bordersListDefaultVariants, ...compact(variants) })

export const bordersList = /* @__PURE__ */ Object.assign(bordersListFn, {
  __recipe__: false,
  __name__: 'bordersList',
  raw: (props) => props,
  variantKeys: bordersListVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, bordersListVariantKeys)
  },
  getVariantProps
})